module.exports = __webpack_public_path__ + "static/media/document.a2a1ae62.svg";